<template>
    <div>
      <div class="flexc-cen-x fixed">
        <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{WZXMName}}</el-breadcrumb-item>
              </el-breadcrumb>
              <el-select v-if="DianList.length>1" style="margin-left:20px;width:140px" size="mini" v-model="SelectStoresID" @change="changedian()" placeholder="门店">
                  <el-option
                        v-for="item in DianList"
                        :key="item.ID"
                        :label="item.StoresName"
                        :value="item.ID">
                  </el-option>
              </el-select>
      </div>
      <div style="padding-top:30px">
          <div class="flex-spc-x" style="width:100%;">
                  <div class="padding-left:5px" style="font-size:15px"> 
                     <el-form :inline="true" :model="formInline" class="flex-cen-x"  style="display:flex;flex-wrap:wrap;">
                    
                       <el-form-item label="">
            <el-input size="mini" v-model="selectMemberName" placeholder="输入姓名、手机号"></el-input>
          </el-form-item>
          <el-form-item label="">
                <el-select  clearable size="mini" v-model="selectshtype">
                    <el-option label="未审核" value="0"></el-option>
                    <el-option label="全额退款" value="1"></el-option>
                    <el-option label="部分退款" value="2"></el-option>
                    <el-option label="驳回审核" value="3"></el-option>
                    <el-option label="直接取消" value="4"></el-option>

                    
                </el-select>
               </el-form-item>
          
  
                         <el-form-item>
                            <el-button size="mini" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                          </el-form-item>
                     </el-form>
                    </div>
                  <div>
                </div>
             
          </div>
  
          <el-table :data="tableData" highlight-current-row v-loading="loading" size="mini"   element-loading-text="拼命加载中" style="width:100%;margin-top:10px">
          <el-table-column  prop="Name" label="姓名"   >
          </el-table-column>
          <el-table-column  prop="Phone" label="联系电话"     >
          </el-table-column>
          <el-table-column  prop="skinfo" label="预约时间"  >
          </el-table-column>
          <el-table-column  prop="sqName" label="申请人"  >
          </el-table-column>
          <el-table-column  prop="addTime" label="申请时间"  >
          </el-table-column>
          <el-table-column  prop="state" label="状态"  >
            <template slot-scope="scope">
                    <span class="Info" v-if="scope.row.shtype == 0">
                        未审核
                    </span>
                    <span class="coBlue" v-if="scope.row.shtype == 1">
                        全额退款
                    </span>
                    <span class="Success" v-if="scope.row.shtype == 2">
                        部分退款
                    </span>
                    <span class="Danger" v-if="scope.row.shtype == 3">
                      驳回审核
                    </span>
                    <span class="Danger" v-if="scope.row.shtype == 4">
                        直接取消
                    </span>
            </template>
          </el-table-column>
          <el-table-column  prop="tkAmount" label="退款金额"  >
          </el-table-column>
          <el-table-column  prop="czName" label="操作人"  >
          </el-table-column>
          <el-table-column  prop="Note" label="备注"  >
          </el-table-column>
        <el-table-column align="center" label="操作" width="380" >
          <template slot-scope="scope">
            <el-button size="mini" type="success" v-if="scope.row.shtype == 0 "    @click="chexiao(scope.row)" >驳回审核</el-button>
            <el-button size="mini" type="info" v-if="scope.row.shtype == 0 "   @click="zjquxiao(scope.row)" >直接取消</el-button>
            <el-button size="mini" type="primary" v-if="scope.row.iszf == 1 && scope.row.shtype == 0 "   @click="quanetk(scope.row)" >全额退款</el-button>
             <el-button size="mini" type="info" v-if="scope.row.iszf == 1 && scope.row.shtype == 0 "  @click="bftk(scope.row)" >部分退款</el-button>
            
           </template>
        </el-table-column>
    </el-table>
      <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  
      </div>
 
      <el-dialog title="驳回" :visible.sync="cheShow" width="40%">
          <el-form label-width="120px">
            <el-form-item label="驳回原因:" prop="Note">
                <el-input type="textarea" :rows="2" placeholder="请输入" v-model="Note" ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="cheShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sureChe()">确定</el-button>
          </div>
      </el-dialog>
      <el-dialog title="直接取消" :visible.sync="weiShow" width="40%">
          <el-form label-width="120px">
            <el-form-item label="取消原因:" prop="Note">
                <el-input type="textarea" :rows="2" placeholder="请输入" v-model="Note" ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="weiShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sureCheqx()">确定</el-button>
          </div>
      </el-dialog>
      <el-dialog title="全额退款" :visible.sync="chongShow" width="40%">
          <el-form label-width="120px">
            <el-form-item label="退款原因:" prop="Note">
                <el-input type="textarea" :rows="2" placeholder="请输入" v-model="Note" ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="chongShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sureCheqetk()">确定</el-button>
          </div>
      </el-dialog>
      <el-dialog title="部分退款" :visible.sync="yuyueShow" width="40%">
          <el-form label-width="120px">
            <el-form-item label="退款金额:" prop="tkAmount" >
                    <el-input size="small" v-model="tkAmount" type="number" auto-complete="off" placeholder="请输入价格"  style="width: 215px"></el-input> 元
            </el-form-item>
            <el-form-item label="退款原因:" prop="Note">
                <el-input type="textarea" :rows="2" placeholder="请输入" v-model="Note" ></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="yuyueShow = false">取消</el-button>
            <el-button size="small" type="primary" :loading="loading"  @click="sureChebftk()">确定</el-button>
          </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  
  import CropperImage from "../../components/CropperImage";
  import  Editor from '../../components/editor'
  
  import {getListManageLogin,addManageLogin,delManageLogin,editManageLogin,editManageLoginmoney,editManageLoginPwd,editManageLoginIsdisable} from "@/api/getData";
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      return {
        title1:'',
        tkAmount:'',
        DianList:[],
        yuyueShow:false,
         RowClassTimeShow:false,
        oldData:null, // 开始排序时按住的旧数据
        newData:null,// 拖拽过程的数据
        preShow:false,
        cropperModel: false,
        hexiaoShow:false,
        addShow:false,
        cardType:'',
        isCode:'',
        code:'',
        MembersID:'',
        MembersID1:'',
        number:'',
        money:'',
        selectshtype:'',
        Amount:'0',
        xhnumber:'1',
        personList:[],
        terName:'',
        mainList:[],
        listRowClassTime:[],
        listRowClassTimeCopy:[],
        StaffID:'',
        PayAmountqt:0,
        vipID:'',
        cropperName: "",
        colorShow:false,
        isEdit:false,
        isedit:0,
        imgName: "",
        sTime: "",
        eTime: "",
        PayAmount:'',
        Timelength:'60',
        TimelengthAmount:'0',
        imgVisible: false,
        PreInfoVisible: false,
        PreInfo:{},
        vipList:[],
        MembersvipList:[],
        iswkyy:'0',
        StimeList:[],
        EtimeList:[],
        siteList:[],
        vipShow:false,
        date:new Date(),
        enddate:new Date(),
        formValidate: {
          mainImage: "",
        },
        cardList:[],
        PreAboutCount:1,
        isPreAboutInfo:1,
        showList:[],
        timer:'',
        allCardName:'',
        value:'1',
        isbxsc:0,
        isMembers:1,
        selectName:'',
         selectMemberName:'',
        selectSiteID:'',
        selectSiteTypeID:'',
        vipName:'',
        vipNames:'',
        isChooseVip:1,
        active:0,
        Note:'',
        hour:'',
        minute:'',
        dateType:'1',
        SiteClassID:'0',
        timeList:[],
        vipShow:false,
 
           
        q1:false,
        q2:false,
        q3:false,
        q4:false,
        q5:false,
        q6:false,
        q7:false,
        q8:false,
        IsPay:localStorage.getItem("IsPay"),
        hyIsPay:localStorage.getItem("hyIsPay"),
        spIsPay:localStorage.getItem("spIsPay"),
        gkIsPay:localStorage.getItem("gkIsPay"),
        hdIsPay:localStorage.getItem("hdIsPay"),
        xmIsPay:localStorage.getItem("xmIsPay"),
        typeName:'',
         Name:'',
        Phone:'',
        name:'全部',
        id:'',
        active:'',
        img1:'',
        img2:'',
        img3:'',
        activeName: 'first',
        SelectStoresID:localStorage.getItem("StoresID"),
        direction: "ltr",
        passShow:false,
        money:'',
        input:'',
        timer:'',
        nshow: true, //switch开启
        fshow: false, //switch关闭
        loading: false, //是显示加载
        editFormVisible: false, //控制编辑页面显示与隐藏
        chongShow:false,
        title: '添加',
        tableData:[],
        sortSure:false,
        SiteTypeName:'',
        siteName:'',
        ListPreAboutForms:[],
        options:[],
        yysc:1,
        iszjyy:"",
        weiShow:false,
        WZCDName: localStorage.getItem('WZCDName'), 
        lay:[
          {
            value:'1',
            label:'必填'
          },
              {
            value:'0',
            label:'选填'
          }
        ],
        
        Pwd:'',
        typeList:[],
        cheShow:false,
        Limits:[],
 
        checkedCycles:[],
 
        startTimenew:"08:00",
        SiteID:0,
        SiteInfo:{},
        SiteClassInfo:{},
        isck:0,
        iscx:0,
 
 
        // rules表单验证
        isCard:localStorage.getItem('isCard'),
 
    name1:'',
        formInline: {
          page: 1,
          limit: 10,
          varLable: '',
          varName: '',
          token: localStorage.getItem('logintoken')
        },
        // 删除部门
        seletedata: {
          ids: '',
          token: localStorage.getItem('logintoken')
        },
        userparm: [], //搜索权限
        listData: [], //用户数据
        // 分页参数
        WZYGName:'',
        WZHYName:'',
        WZXMName:'',
        WZPBName:'',
        subList:[],
        cardList:[],
        ListSiteClassTime:[],
        subName:'',
        MembersSubID:'',  
        RowClassTimeID:'', 
        timeShow:false,
        timeList:[],
        yyList:[],
        
        personShow:false,
        SiteEdit:false,
        days:'',
        times:'',
        SleletyyTime:'',
         info:[],
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        }
      }
    },
    // 注册组件
    components: {
      Editor,
      Pagination,
      CropperImage,
    },
    /**
     * 数据发生改变
     */
  
    /**
     * 创建完毕
     */
    created() {
      
        if(localStorage.getItem('isAdmin') == 1){
            this.q1 = true
            this.q2 = true
            this.q3 = true
            this.q4 = true
            this.q5 = true
            this.q6 = true
            this.q7 = true
            this.q8 = true
        }else{
            this.Limits = localStorage.getItem('Limits')
        this.Limits = this.Limits.split(',')
        this.Limits.forEach(items => {
              // if(items == 162){
              //   this.q1 = true
              // }
              if(items == 182){
                this.q2 = true
              }
              if(items == 183){
                this.q3 = true
              }
              if(items == 184){
                this.q4 = true
              }
              if(items == 185){
                this.q5 = true
              }
              
            
      })
        }
    
  
  
  
   
        this.getList()
   
    
     },
  
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
 
 
  
              forceUpdate () { 
      this.$forceUpdate() 
    }, bftk(row){
          this.mainList = row
          this.tkAmount = 0
          this.Note = ''
          this.yuyueShow = true

      },sureChebftk(){
        if(this.Note == ''){
           this.$message({ type: "error", message: "请输入原因" ,duration:1000});
            return;
        }
        if(this.tkAmount <= 0 ){
           this.$message({ type: "error", message: "请输入金额" ,duration:1000});
            return;
        }
        var that = this
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  QXPrecdexamineID:this.mainList.ID,
                  shtype:2,
                  sourceName:localStorage.getItem("Name"),
                  loginID:localStorage.getItem("LoginID"),
                  Note:this.Note,
                  tkAmount:this.tkAmount,
                }
                this.ajax('editQXPrecdexaminetkAmount.aspx',JSON.stringify(data),"POST",function(res){
  
                  if (res.orsuccess == "1") {
  
                      that.$message({
                        type: "success",
                        message: res.Msg,duration:2000,
                      });
                     that.yuyueShow = false
 
                     that.getList();
                   
                    }
                })
            
          
      }  ,quanetk(row){
          this.mainList = row
          this.chongShow = true
          this.Note = ''
      },sureCheqetk(){
        if(this.Note == ''){
           this.$message({ type: "error", message: "请输入原因" ,duration:1000});
           return;
        }
       
        var that = this
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  QXPrecdexamineID:this.mainList.ID,
                  shtype:1,
                  sourceName:localStorage.getItem("Name"),
                  loginID:localStorage.getItem("LoginID"),
                  Note:this.Note,
                }
                this.ajax('editPreAboutStateCDSHTK.aspx',JSON.stringify(data),"POST",function(res){
  
                  if (res.orsuccess == "1") {
  
                      that.$message({
                        type: "success",
                        message: res.Msg,duration:2000,
                      });
                     that.chongShow = false
 
                     that.getList();
                   
                    }
                })
            
          
      },
    zjquxiao(row){
          this.mainList = row
          this.weiShow = true
          this.Note = ''
      },sureCheqx(){
        if(this.Note == ''){
           this.$message({ type: "error", message: "请输入原因" ,duration:1000});
           return;
        }
       
        var that = this
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  QXPrecdexamineID:this.mainList.ID,
                  shtype:4,
                  sourceName:localStorage.getItem("Name"),
                  LoginID:localStorage.getItem("LoginID"),
                  Note:this.Note,
                }
                this.ajax('editQXPrecdexaminezjqx.aspx',JSON.stringify(data),"POST",function(res){
  
                  if (res.orsuccess == "1") {
  
                      that.$message({
                        type: "success",
                        message: res.Msg,duration:2000,
                      });
                     that.weiShow = false
 
                     that.getList();
                   
                    }
                })
            
          
      },  
    chexiao(row){
          this.mainList = row
          this.cheShow = true
          this.Note = ''
      },  sureChe(){
        if(this.Note == ''){
           this.$message({ type: "error", message: "请输入原因" ,duration:1000});
          return;
        }
       
        var that = this
         
                var data = { 
                  SelectStoresID:this.SelectStoresID,
                  StoresID:localStorage.getItem("StoresID"),
                  token: localStorage.getItem("token"),
                  QXPrecdexamineID:this.mainList.ID,
                  shtype:3,
                  sourceName:localStorage.getItem("Name"),
                  LoginID:localStorage.getItem("LoginID"),
                  Note:this.Note,
                }
                this.ajax('editQXPrecdexamineshtype.aspx',JSON.stringify(data),"POST",function(res){
  
                  if (res.orsuccess == "1") {
  
                      that.$message({
                        type: "success",
                        message: res.Msg,duration:2000,
                      });
                     that.cheShow = false
 
                     that.getList();
                   
                    }
                })
            
          
      }, 
        handleClick(){
            this.getList()
        },
 
   
     
        changedian(){
        this.pageparm ={
          currentPage: 1,
          pageSize: 10,
          total: 0,
        },
       this.getList()
       },
 
 
 
      getList(){
     
  var data = { 
            SelectStoresID:this.SelectStoresID,        
              token: localStorage.getItem("token"),
              StoresID:localStorage.getItem("StoresID"),
              shtype:this.selectshtype,
              selectName:this.selectMemberName,
              pages:this.formInline.page,
             psize:this.formInline.limit,
              
          }
          const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
          
          var that = this
          this.ajax('getListQXPrecdexamine.aspx',JSON.stringify(data),"POST",function(res){
              if (res.orsuccess == "1") {
                    that.tableLoading = false
                     that.tableData = res.data
                     that.pageparm.total = res.allcount

             
             
                     loading.close();
              } 
  
          })
      },
    
      // 获取公司列表
  
  
      //图片上传成功后
  
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getList()
      },
      // 搜索事件
      search() {
        this.getList()
      },
  
  
 
    }
  }
  </script>
  
  <style scoped>
  .hidden{
    height: 48vh;
    overflow: auto;
  }
  .mian{
    height: 300px;
    overflow: auto;
    overflow-x: hidden
  }
  .hen{
    width: 95%;
    border: 1px dashed #65a8ff;
    margin-left: 2.5%;
    padding-top:10px;
    padding-bottom: 10px;
  }
  .mainTitle{
    border-radius: 5px;
    width: 95%;
    height: 95%;
    background-color: white;
  }
  .left{
    background-color: #e0e0e0;
  }
  .jingp{
    width:50px;
  
    margin-left: 10px;
    font-size: 13px;
  }
  .kuai{
    margin-left: 10px;
    border-radius: 20px;
    width: 20px;
    height: 20px;
  }
  .bgColor{
    width:215px;
    height:30px;
    border:1px solid #808080;
    margin-top:5px;
    border-radius: 4px;
  }
  .main{
    position: absolute;
  }
  .content{
    font-size: 14px;
    color: #999;
    line-height: 20px;
  }
  .titleMain{
      font-size: 14px;
      color: #191919;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
  }
  .offline___NHq4e1 {
      position: absolute;
      top:  100px;
      right: 11px;
      padding: 0.5px 4px 0.5px 4px;
   
      font-size: 15px;
      line-height: 20px;
      color: #3709dc;
  
  }
  .offline___NHq4e2 {
      position: absolute;
      top:  100px;
      right: 51px;
      padding: 0.5px 4px 0.5px 4px;
   
      font-size: 15px;
      line-height: 20px;
      color: #3709dc;
  
  }
  .offline___NHq4e {
      position: absolute;
      top: -1px;
      right: -1px;
      padding: 0.5px 4px 0.5px 4px;
      /* width: 64px; */
      /* height: 22px; */
      background: rgba(255, 101, 247, 0.04);
      border-radius: 0 8px 0 8px;
      border: 1px solid rgba(187, 14, 255, 0.2);
      font-size: 12px;
      text-align: center;
      line-height: 20px;
      color: #b336fc;
  }
  .box{
    position: relative;
      width: calc((100% - 80px)/4);
      padding: 20px;
      box-sizing: border-box;
      display: inline-block;
      margin-right: 16px;
      margin-bottom: 16px;
      border-radius: 8px;
      border: 1px solid #ececec;
      box-shadow: 0 4px 8px 0 rgb(0 0 0 / 8%);
      height: 130px;
  }
  @media screen and ( max-width: 1400px ) {
    .box{
      cursor: pointer;
      width: calc((100% - 70px)/3);
    }
  }
  .box:hover{
    box-shadow: 0 4px 16px 0 rgb(0 0 0 / 16%);
  }
  .shadow:hover {
      border:1px solid #409EFF;border-radius:2px
  }
  .shadow {
      border:1px solid #ffffff;border-radius:2px
  }.{
    overflow: auto;
  }
  .xiang{
      padding: 1px 4px  1px 4px;
      background-color: #f7f7f7;
      border:1px solid #bbbbbb;
      border-radius: 3px;
      font-size: 10px;
      color:#bbbbbb;
  }
    
  /* .el-switch__core::after{
   height: 12px !important;
   width :12px !important;
  } */
     
  .title{
      margin-top: 10px;
      height: 30px;
      font-size: 13px;
      font-weight: bolder;
      border-radius: 3px;
      border-left: 5px solid #334157;
  
  }
  .user-search {
    margin-top: 20px;
  }
  .userRole {
    width: 100%;
  }
  .f-mt-10 {
      margin-top: 10px;
  }
  .itemWrap___33SF3 {
      text-align: left;
      margin-bottom: 8px;
      padding: 0 12px;
      line-height: 40px;
      background: #e6f7ff;
      border-radius: 8px;
   }
   .g-items-wrap {
      padding: 10px 15px;
      border: 1px dashed #40a9ff;
  }
   .cell {
      text-align: center;
      box-sizing: border-box;
      background: greenyellow;
  
    }
   
    .cell2{
      text-align: center;
      background: lightskyblue;
      box-sizing: border-box;
    }
  
   
    /* .mytd:hover{
       
      border: 2px solid blue;
    } */
  
  .all .move-table,
              .fixed-l,
              .fixed-r {
                  /* background-color: #D5E4E4; */
                  word-break: keep-all;
                  width: 100%;
              }
              .fixed-l th,
              .all .move-table th,
              .fixed-r th,
              .fixed-l td,
              .fixed-r td,
              .all .move-table td {
                  width: 150px;
                  text-align: center;
                  border: 1px solid #E2E2E2;
                  height: 40px;
                  min-width: 150px;
                  max-width: 150px;
              }
              
              .l {
                  position: absolute;;
                  z-index: 5;
                  top: 0;
                  left: 0;
              }
              .r {
                  position: absolute;
                  z-index: 5;
                  top: 0;
                  right: 0;
              }
  
        .left {
          float: left;
          width: 155x;
          height: 100%;
          background-color: rgb(255, 255, 255);
        }
        .right {
          /* background-color: orange; */
          margin-left: 160px;
          height: 100%;
        }
   
   
  </style>
  


// WEBPACK FOOTER //
// src/views/site/siteMainSHList.vue